import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { redirectToDocs } from 'utils/redirectToDocs';

import { TOTPSetup } from '@pages/TOTPSetup';
import { RedirectToDefaultOrganisation } from 'containers/redirections/DefaultOrganisationRedirection';

import { setCredentials } from 'reduxLocal/slices/authSlice';

import { useAccessToken } from 'hooks/context';
import { useMfaSettings } from 'hooks/useMfaSettings';
import { useRedirectTo } from 'hooks/useRedirectTo';

export const MfaSetup = () => {
  const { totpEnabled, loading } = useMfaSettings();

  const [searchParams] = useSearchParams();
  const fromDocsFlag = searchParams.get('fromDocs') ?? null;

  const dispatch = useDispatch();

  const { setAccessToken } = useAccessToken();

  const { navigateWithRedirectTo } = useRedirectTo();

  async function onSuccess({ access_token }: { access_token: string }) {
    // for v1 calls
    dispatch(setCredentials({ access_token }));
    // for v2 calls
    setAccessToken(access_token);

    if (fromDocsFlag) {
      redirectToDocs();
      return;
    }

    navigateWithRedirectTo('/login_transition', {
      state: { loggingIn: true }
    });
  }

  if (loading) {
    return null;
  }

  if (!totpEnabled) {
    return <TOTPSetup onSuccess={onSuccess} />;
  }

  return <RedirectToDefaultOrganisation />;
};
